module.exports = __webpack_public_path__ + "img/progress-active.cbc103ef.svg";